



































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class AssessmentActionsSpeedDial extends Vue {
  @Prop({ type: Boolean, required: true }) fab!: boolean;

  @Prop({ type: Boolean, required: true }) loadingSave!: boolean;

  @Prop({ type: Boolean, required: true }) showEditButton!: boolean;

  @Prop({ type: Boolean, required: true }) showSaveButton!: boolean;
}

export default AssessmentActionsSpeedDial;
